// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';
import Checkbox from 'presentations/views/components/atoms/Checkbox';
import { Props } from './types';
import { CancelReasonType } from 'domains/models/subscription/cancel_reason/cancel_reason_type';
import TextArea from 'presentations/views/components/atoms/TextArea';
import { fontSize, spacing } from 'presentations/views/styles';

const radioGroupName = 'cancelReason';

const cancelReasons = [
  CancelReasonType.AnotherProduct,
  CancelReasonType.LessFeatures,
  CancelReasonType.LowUsage,
  CancelReasonType.Expensive,
  CancelReasonType.SupportIssues,
  CancelReasonType.HardToUse,
  CancelReasonType.Bugs,
  CancelReasonType.ChangeOrganization,
  CancelReasonType.TemporaryUsage,
  CancelReasonType.Other,
];

export default function CancelRasonList(props: Props) {
  const t = translateInComponent(translations);

  return (
    <StyledContainer>
      {cancelReasons.map((reason) => {
        const isChecked = props.value.includes(reason);
        const isAskForDetail = props.askForDetailCancelReason.includes(reason);

        return (
          <StyledItem key={`reason_${reason}`}>
            <Checkbox
              name={radioGroupName}
              value={reason}
              isChecked={isChecked}
              onChange={props.onChange}
              label={
                <StyledCheckboxLabel>
                  {t(`reason${reason}`)}
                </StyledCheckboxLabel>
              }
            />
            {isAskForDetail && isChecked && (
              <StyledDetail>
                {t(`reason${reason}-1`) ? (
                  <StyledDetailText>{t(`reason${reason}-1`)}</StyledDetailText>
                ) : null}
                <TextArea
                  id={`cancelReason${reason}`}
                  name="askForDetail"
                  value={props.askForDetail[reason]}
                  onChange={props.onChangeAskForDetail}
                  isFullWidth
                  rows={2}
                  maxRows={5}
                  placeholder={t('placeholder', {
                    label: t(`placeholder${reason}`),
                  })}
                />
              </StyledDetail>
            )}
          </StyledItem>
        );
      })}
    </StyledContainer>
  );
}

const StyledContainer = styled.ul``;
const StyledItem = styled.li`
  list-style: none;
`;
const StyledDetail = styled.div`
  margin-top: ${spacing(4)};
  margin-left: ${spacing(36)};
  margin-bottom: ${spacing(4)};
`;
const StyledDetailText = styled.div`
  margin-bottom: ${spacing(4)};
  font-size: ${fontSize(14)};
`;
const StyledCheckboxLabel = styled.div`
  font-size: ${fontSize(14)};
`;
